<mdb-sidenav-layout *ngIf="isLoggedIn" style="font-family: 'Work Sans';">
	<mdb-sidenav #sidenav="mdbSidenav" [mode]="mode" [position]="'fixed'" [hidden]="hidden" [slim]="slim"
		[slimCollapsed]="slimCollapsed" [slimWidth]="slimWidth" [backdrop]="backdrop" [closeOnEsc]="closeOnEsc"
		[transitionDuration]="0" [width]="400">
		<div class="sidebar-header d-flex align-items-middle" [style.background-color]="bgSidenav"
			[style.border-bottom]="'solid 1px ' + secondaryColor">
<button id="btn-toggle-slim" mdbRipple rippleColor="light" (click)="sidenav.toggleSlim()"
				[style.background-color]="secondaryColor">
				<i class="fas fa-bars"></i>
			</button>
			<div class="text-center logo" slim="false">
				<img [src]="Logo" />
			</div>
		</div>
		<ul class="sidenav-menu pt-2" [style.background-color]="bgSidenav">
			<mdb-sidenav-item>
				<a class="sidenav-link" tabindex="0" mdbRipple [href]="'/home'" [style.color]="textLight">
					<img src="./assets/images/sidenav-icons/blanco/inicio.svg" class="sidenav-link-icon" />
					<span class=" ms-2" slim="false">Inicio</span>
				</a>
			</mdb-sidenav-item>
			<ng-container *ngIf="menuData">
				<ng-container *ngFor="let category of menuData.detail">
					<mdb-sidenav-item *ngIf="category.Menu.ISDINAMYC!=false" >

						<!--<a class="sidenav-link" tabindex="0" mdbRipple
							[href]="category.Menu.link ? category.Menu.link : '#'" [style.color]="textLight">
							<img [src]="'./assets/images/sidenav-icons/blanco/' + category.Menu.icon "
								class="sidenav-link-icon" />
							<span class=" ms-2" slim="false">{{ category.Menu.label }}</span>
						</a> -->

						<a class="sidenav-link" tabindex="0" mdbRipple [style.color]="textLight"
							[routerLink]="category.Menu.link ? [category.Menu.link] : null" 
							(click)="onMenuClick(category.Menu)">
							<img [src]="'./assets/images/sidenav-icons/blanco/' + category.Menu.icon "
								class="sidenav-link-icon" />
							<span class="ms-2" slim="false">{{ category.Menu.label }}</span>
						</a>

						<ul *ngIf="category.Menu.submenu" class="sidenav-collapse" mdbCollapse>
							<ng-container *ngFor="let detail of menuData.detail">
								<li class="sidenav-item" *ngFor="let submenu of detail.Menu.submenu">
									<a (click)="onMenuClick(category.Menu)" [href]="submenu.link" class="sidenav-link" tabindex="0" [style.color]="textLight" mdbRipple>{{ submenu.label }}</a>
								</li>
							</ng-container>
						</ul>
					</mdb-sidenav-item>
				</ng-container>
			</ng-container>
		</ul>
	</mdb-sidenav>
	<mdb-sidenav-content #sidenavContent>
		<!-- Navbar -->
		<nav id="main-navbar" class="navbar navbar-expand-lg navbar-light bg-white fixed-top p-0" [ngClass]="'show'">
			<!-- Container wrapper -->
			<div class="container-fluid ps-0" style="margin-left:70px;">
				<div mdbDropdown class="dropdown dropdown-company me-2">
					<button
					class="btn dropdown-toggle rounded-0 border-end"
					type="button"
					id="dropdownCompanyButton"
					aria-expanded="false"
					mdbDropdownToggle
					>
						<img [src]="Logo" />
					</button>
					<ul
						mdbDropdownMenu
						class="dropdown-menu"
						aria-labelledby="dropdownCompanyButton"
					>
						<li *ngFor="let company of companies">
							<button class="dropdown-item" (click)="fillAppDropdown(company.value)">{{ company.label }}</button>
						</li>
					</ul>
				</div> 
      
				<mdb-form-control>
					<mdb-select [(ngModel)]="appForm.appId" (valueChange)="rebuildMenu($event, companyForm.companyId)"
						class="select-app" placeholder="Seleccione aplicación">
						<mdb-option *ngIf="appDefault==true" [value]="0" disabled>Seleccione aplicación</mdb-option>
						<mdb-option *ngFor="let app of apps" [value]="app.value">
							{{ app.label }}
						</mdb-option>
					</mdb-select>
					<!--label mdbLabel class="form-label label-app">Seleccione la aplicación:</label-->
				</mdb-form-control>
				<!-- Right links -->
				<ul class="navbar-nav ms-auto d-flex flex-row">
					<!-- Notification dropdown -->
					<li mdbDropdown class="nav-item dropdown">
						<a mdbDropdownToggle class="nav-link me-3 me-lg-0 dropdown-toggle hidden-arrow"
							id="navbarDropdownMenuLink" role="button" aria-expanded="false">
							<!--<i class="fas fa-bell"></i>
                <span class="badge rounded-pill badge-notification bg-danger">1</span> -->
						</a>
						<ul mdbDropdownMenu class="dropdown-menu dropdown-menu-end"
							aria-labelledby="navbarDropdownMenuLink">
							<li><a class="dropdown-item">Some news</a></li>
							<li><a class="dropdown-item">Another news</a></li>
							<li>
								<a class="dropdown-item">Something else here</a>
							</li>
						</ul>
					</li>

					<!-- Avatar -->
					<li mdbDropdown class="nav-item dropdown">
						<a mdbDropdownToggle
							class="nav-link dropdown-toggle hidden-arrow d-flex align-items-center px-2 h-100"
							id="navbarDropdownMenuLink" role="button" aria-expanded="false">
							<span class="user text-light d-flex align-items-middle justify-content-center"
								[style.background-color]="primaryColor">
								<i class="fas fa-user-alt"></i>
							</span>
						</a>
						<ul mdbDropdownMenu class="dropdown-menu dropdown-menu-end"
							aria-labelledby="navbarDropdownMenuLink">
							<!--<li><a class="dropdown-item">My profile</a></li>
                <li><a class="dropdown-item">Settings</a></li> -->
							<li style="cursor: pointer;" (click)="logout()"><a class="dropdown-item">Logout</a></li>
						</ul>
					</li>
				</ul>
			</div>
			<!-- Container wrapper -->
		</nav>
		<!-- Navbar -->

		<main style="margin-top: 70px;margin-left:70px;" class="pb-5">
			<router-outlet></router-outlet>
		</main>
	</mdb-sidenav-content>
</mdb-sidenav-layout>

<main *ngIf="!isLoggedIn">
	<router-outlet></router-outlet>
</main>

<mdb-loading [show]="loadingCompanyApp" [fullscreen]="true">
	<div class="loading-spinner" >
	  <div class="spinner-border loading-icon" role="status"></div>
	  <span class="loading-text">Cargando datos...</span>
	</div>
</mdb-loading>